import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    cartRequestInProcess: boolean;
}>;

export const DispatchSetCartRequestInProcess: HandlerType = props => {
    props.dispatch({
        type: "Pages/VmiBins/SetCartRequestInProcess",
        cartRequestInProcess: props.parameter.cartRequestInProcess,
    });
};

export const chain = [DispatchSetCartRequestInProcess];

const setCartRequestInProcess = createHandlerChainRunner(chain, "SetCartRequestInProcess");
export default setCartRequestInProcess;
